import React, { useEffect } from 'react';
import {
  Form,
  FormInstance,
  SelectBooleanInput,
  SelectInput
} from 'blueprint-form';
import { Option } from 'blueprint-form/components/types';
import { Row, Col } from '../../../../grid';
import { CardBlock } from '../../../organisms/card';

interface EpxCOPDSettingsData {
  alerts?: boolean;
  afterHourInfo?: boolean;
  trigger?: number;
}

const DefaultSettings: EpxCOPDSettingsData = {
  alerts: true,
  afterHourInfo: false,
  trigger: 1
};

interface EpxCOPDSettingsProps {
  setForm?: (form: FormInstance<EpxCOPDSettingsData>) => void;
  onSubmit?: (data: EpxCOPDSettingsData) => void;
  disabled?: boolean;
}

const EpxCOPDSettings = ({
  setForm,
  onSubmit: _onSubmit,
  disabled
}: EpxCOPDSettingsProps): JSX.Element => {
  const form = new FormInstance<EpxCOPDSettingsData>(DefaultSettings);
  const triggerOptions: Option[] = [];
  for (let i = 1; i <= 7; i++) {
    triggerOptions.push({
      label: i === 1 ? `${i} dyspnea event` : `${i} consecutive dyspnea events`,
      value: i
    });
  }
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  const onSubmit = (data: EpxCOPDSettingsData) => {
    _onSubmit({
      ...data,
      trigger: parseInt(String(data.trigger), 10)
    });
  };
  return (
    <CardBlock bare>
      <Form form={form} onSubmit={onSubmit}>
        <CardBlock>
          <Row>
            <Col sm={12}>
              <SelectBooleanInput
                label="Enable Alerts for Patient"
                name="alerts"
                fill
                disabled={disabled}
              />
            </Col>
            <Col sm={12}>
              <SelectBooleanInput
                label="Inform Business Hour"
                name="afterHourInfo"
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <SelectInput
                label="Trigger Alert When"
                name="trigger"
                fill
                disabled={disabled}
                options={triggerOptions}
              />
            </Col>
          </Row>
        </CardBlock>
      </Form>
    </CardBlock>
  );
};

export default EpxCOPDSettings;
